import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { ConsultPlacesCard } from './consult_places_card.js';

export const consultPlacesEntry: GenUiEntry<Extract<ChatUi, { kind: 'consult_places' }>> = {
  kind: 'consult_places',
  slot: 'chat',
  render: (props) => <ConsultPlacesCard {...props} />,
};
